<script>
  import {
    VCheckbox
  } from 'vuetify/lib'
  export default {
    name: 'wh-checkbox',
    extends: VCheckbox
  };
</script>